<template>
    <section class="home-container">
        <MasterPage title="营养物质">
            <div slot="title-icon">
                <Icon type="ios-nutrition" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="中文名称：">
                            <Input v-model="name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="英文名称：">
                            <Input v-model="englishName" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="简称：">
                            <Input v-model="forShort" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="状态：">
                            <Select v-model="isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindMutrition">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增营养物质" @on-cancel="cancelItem">
            <Form :label-width="80">
                <FormItem label="中文名称：">
                    <Input v-model="itemAdd.name" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem label="英文名称：">
                    <Input v-model="itemAdd.englishName" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem label="简称：">
                    <Input autocomplete="new-password"  v-model="itemAdd.forShort" placeholder="请输入" />
                </FormItem>
                <FormItem label="单位：">
                    <Input  autocomplete="new-password" v-model="itemAdd.unit" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addMutrition">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改营养物质" @on-cancel="cancelItem">
            <Form :label-width="80">
                <FormItem label="中文名称：">
                    <Input v-model="itemAdd.name" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem label="英文名称：">
                    <Input v-model="itemAdd.englishName" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem label="简称：">
                    <Input autocomplete="new-password"  v-model="itemAdd.forShort" placeholder="请输入" />
                </FormItem>
                <FormItem label="单位：">
                    <Input  autocomplete="new-password" v-model="itemAdd.unit" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateMutrition">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '中文名称',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '英文名称',
                        key: 'englishName',
                        align: 'center',
                    },
                    {
                        title: '简称',
                        key: 'forShort',
                        align: 'center',
                    },
                    {
                        title: '单位',
                        key: 'unit',
                        align: 'center',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:160,
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'md-unlock',
                                        label:"small",
                                    },
                                    on: {
                                        click: () => {
                                            this.reuseMutrition_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '启用')
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateMutrition_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteMutrition_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                ]);
                            }
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                name:'',
                englishName:'',
                forShort:'',
                isDeleted:'false',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                itemAdd:{
                    id:'',
                    name:'',
                    englishName:'',
                    unit:'',
                    forShort:'',
                }
            }
        },
        created(){
            this.pageFindMutrition()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindMutrition()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindMutrition()
            },
            pageFindMutrition(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('nutrition/list',{
                    name:this.name,
                    englishName:this.englishName,
                    forShort:this.forShort,
                    isDeleted:this.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'营养物质查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addMutrition(){
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入营养物质中文名称');
                }
                if (this.itemAdd.englishName.length <= 0){
                    return this.$Message.warning('请输入营养物质英文名称');
                }
                if (this.itemAdd.unit.length <= 0){
                    return this.$Message.warning('请输入营养物质单位');
                }
                if (this.itemAdd.forShort.length <= 0){
                    return this.$Message.warning('请输入营养物质简称');
                }
                this.addLoading = true
                this.$http.post('nutrition/add',{
                    name:this.itemAdd.name,
                    englishName:this.itemAdd.englishName,
                    unit:this.itemAdd.unit,
                    forShort:this.itemAdd.forShort
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养物质新增成功'});
                        this.pageFindMutrition()
                    }else {
                        this.$Notice.error({title:'营养物质新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateMutrition_modal(mutrition){
                this.itemAdd.id = mutrition.id
                this.itemAdd.name = mutrition.name
                this.itemAdd.englishName = mutrition.englishName
                this.itemAdd.unit = mutrition.unit
                this.itemAdd.forShort = mutrition.forShort
                this.updateModel = true
            },
            updateMutrition(){
                if (this.itemAdd.name.length <= 0){
                    return this.$Message.warning('请输入营养物质中文名称');
                }
                if (this.itemAdd.englishName.length <= 0){
                    return this.$Message.warning('请输入营养物质英文名称');
                }
                if (this.itemAdd.unit.length <= 0){
                    return this.$Message.warning('请输入营养物质单位');
                }
                if (this.itemAdd.forShort.length <= 0){
                    return this.$Message.warning('请输入营养物质简称');
                }
                this.updateLoading = true
                this.$http.post('nutrition/update',{
                    id:this.itemAdd.id,
                    name:this.itemAdd.name,
                    englishName:this.itemAdd.englishName,
                    unit:this.itemAdd.unit,
                    forShort:this.itemAdd.forShort
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养物质修改成功'});
                        this.pageFindMutrition()
                    }else {
                        this.$Notice.error({title:'营养物质修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = false
                this.itemAdd.id = this.itemAdd.name = this.itemAdd.englishName = this.itemAdd.unit = this.itemAdd.forShort = ''
            },
            deleteMutrition_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用营养物质“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteMutrition(item);
                    }
                });
            },
            deleteMutrition(item){
                this.$http.post('nutrition/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养物质禁用成功'});
                        this.pageFindMutrition()
                    }else {
                        this.$Notice.error({title:'营养物质禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            reuseMutrition_modal(item){
                this.$Modal.confirm({
                    title: '确认启用营养物质“'+item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseMutrition(item);
                    }
                });
            },
            reuseMutrition(item){
                this.$http.post('nutrition/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '营养物质启用成功'});
                        this.pageFindMutrition()
                    }else {
                        this.$Notice.error({title:'营养物质启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>

